import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { Formik, Form } from "formik";
import TrfFormFields from "../TrfFormFields";
import { resignationInitialValues, resignValidationSchema } from "../../../mailTemplate/ResignationApproval/helper/resignationApprovalHelper";
import { useGetApiRequests } from "../../../../common/CommonExport";
import { createPayload, getTrfDetails, trfCreateEditApi } from "./TRFHelper";
import ModalLoader from "../../../../components/Loader/ModalLoader";
import PopupModal from "../../../employee/employee-details/employee-profile/modal/PopupModal";
import { useSelector } from "react-redux";

interface FunctionProps {
  open: boolean;
  [key: string]: any;
}
const TRFUpdateModal = (props: FunctionProps) => {
  const { open, handleClose, editRecord, designationGetApi, searchQuery, isEdit } = props;
  const orgName = useSelector((state: any) => state?.organisationName?.orgName);
  const trfDetailsApi = useGetApiRequests("trfForm", "GET");
  const trfDetailUpdate = useGetApiRequests("trfForm", isEdit ? "PUT" : "POST");
  const [initialValues, setInitialValues] = useState<any>({ ...resignationInitialValues, company: orgName });
  const [loader, setLoader] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>("");
  const [modalResponse, setModalResponse] = useState<string>("");
  const [modalButton, setModalButton] = useState<boolean>(false);
  useEffect(() => {
    if (editRecord?.key && isEdit) {
      setLoader(true);
      // Get Api call
      getTrfDetails({ orgName, trfDetailsApi, editRecord, setInitialValues, initialValues, setLoader });
    }
  }, [editRecord?.key]);

  const onSubmit = async (values: any) => {
    setLoader(true);
    const payload = createPayload({ editRecord, values, isEdit });
    // create update API Call
    trfCreateEditApi({
      setLoader,
      payload,
      trfDetailUpdate,
      editRecord,
      setModalOpen,
      setModalResponse,
      setModalMessage,
      handleClosePopUpModal,
      handleClose,
      designationGetApi,
      searchQuery,
      setModalButton,
    });
  };

  const handleClosePopUpModal = () => {
    setModalOpen(false);
  };
  return (
    <div className="!w-[60%]">
      <Modal className="!w-[60%]" title={isEdit ? "Edit Talent Requisition Form" : "Create Talent Requisition Form"} centered open={open} footer={null} onCancel={handleClose} maskClosable={false}>
        {loader && <ModalLoader />}
        <Formik validationSchema={resignValidationSchema(null, true)} initialValues={initialValues} onSubmit={onSubmit} values={initialValues} enableReinitialize={true}>
          {({ values, setFieldValue, errors }) => {
            return (
              <Form>
                <div className={`grid grid-cols-1 pt-4 pb-10 mb-0 `}>
                  <TrfFormFields values={values} setFieldValue={setFieldValue} isEdit={isEdit} />
                </div>

                <div className="flex justify-center gap-3">
                  <button className="addButton secondary mr-4" onClick={handleClose}>
                    Cancel
                  </button>
                  <button className="addButton mr-4" type="submit">
                    Update
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
        <PopupModal message={modalMessage} open={modalOpen} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButton} />
      </Modal>
    </div>
  );
};

export default TRFUpdateModal;
